/**
 * 收藏单商品
 */
import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { favoMobx } from 'mobx/mall'
import Empty from '../Empty'
import ProductItem from '../ProductItem'
import './index.scss'

const ProductItems: FC = () => {
  return (
    <div className='mall-favo-product-wrapper'>
      {
        favoMobx.productList.length ? (
          <section>
            {favoMobx.productList
              .map((product, index) => (
                <div key={index}>
                  <ProductItem product={product} index={index} />
                </div>
              ))}
          </section>
        ) : ( // 无商品
          <Empty />
        )
      }
    </div>
  )
}

export default observer(ProductItems)
